import FirmProfile from "./FirmProfile";

function FirmOnboardingWizard() {
  return <FirmProfile mode="onboarding" />;
}

export default FirmOnboardingWizard;
